// extracted by mini-css-extract-plugin
module.exports = {"promptHolder":"AddFarmPrompt_promptHolder__1qxGo","subTitle":"AddFarmPrompt_subTitle__rH2FN"};